var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1Current(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 68,
    cy: 68,
    r: 68,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 68,
    cy: 68,
    r: 62,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 124C98.9279 124 124 98.9279 124 68C124 37.0721 98.9279 12 68 12C37.0721 12 12 37.0721 12 68C12 98.9279 37.0721 124 68 124Z",
    fill: "#A0576E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41 35.3131C103.409 35.3941 103.382 35.4728 103.335 35.5386C103.288 35.6044 103.221 35.6541 103.145 35.6811L102.556 35.9019C100.049 36.9318 97.9044 38.6836 96.3949 40.9349C94.8853 43.1861 94.0789 45.8352 94.0779 48.5457V87.007C94.0799 88.8014 93.7279 90.5785 93.0421 92.2366C92.3563 93.8947 91.3503 95.4013 90.0815 96.6701C88.8127 97.9388 87.3061 98.9449 85.648 99.6307C83.9899 100.316 82.2128 100.668 80.4185 100.666H36.1136C36.0589 100.669 36.0044 100.659 35.9535 100.639C35.9025 100.619 35.8563 100.589 35.8176 100.55C35.7789 100.512 35.7486 100.465 35.7286 100.414C35.7086 100.364 35.6994 100.309 35.7015 100.254C35.7017 100.167 35.7307 100.082 35.7839 100.013C35.8371 99.944 35.9116 99.8943 35.9958 99.8717L36.5846 99.6361C39.0851 98.6042 41.223 96.8531 42.7271 94.6048C44.2313 92.3564 45.0339 89.7121 45.0334 87.007V48.5604C45.0446 45.4823 46.0963 42.4983 48.0176 40.0934C49.9389 37.6884 52.6169 36.0038 55.6166 35.3131C56.6247 35.0755 57.6572 34.9569 58.6929 34.9598H102.998C103.098 34.9555 103.197 34.9896 103.274 35.0551C103.35 35.1207 103.399 35.2129 103.41 35.3131Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0351 47.8098H51.2598V59.5852H63.0351V47.8098Z",
    fill: "#EEC98A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0352 70.1392H51.2598V81.9146H63.0352V70.1392Z",
    fill: "#EEC98A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.317 58.6664H56.2345C56.0019 58.6547 55.7743 58.5912 55.5667 58.4801C55.359 58.3689 55.176 58.2127 55.0295 58.0216L51.2497 53.0374C50.9761 52.6745 50.8502 52.2118 50.8997 51.751C50.9493 51.2902 51.1701 50.869 51.5138 50.5801C51.8574 50.2912 52.2957 50.1583 52.7321 50.2106C53.1686 50.2629 53.5675 50.4961 53.8411 50.859L56.4491 54.3444L63.6291 46.7287C63.9384 46.4041 64.3567 46.2219 64.7928 46.2219C65.2289 46.2219 65.6472 46.4041 65.9565 46.7287C66.1112 46.8907 66.234 47.0835 66.3178 47.2958C66.4016 47.5082 66.4447 47.736 66.4447 47.966C66.4447 48.1961 66.4016 48.4239 66.3178 48.6362C66.234 48.8486 66.1112 49.0414 65.9565 49.2034L57.4724 58.161C57.165 58.4829 56.75 58.6644 56.317 58.6664Z",
    fill: "#302322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.317 80.4439H56.2345C56.0019 80.4323 55.7743 80.3688 55.5667 80.2576C55.359 80.1465 55.176 79.9903 55.0295 79.7991L51.2497 74.8149C50.9761 74.4521 50.8502 73.9894 50.8997 73.5286C50.9493 73.0678 51.1701 72.6466 51.5138 72.3577C51.8574 72.0688 52.2957 71.9359 52.7321 71.9882C53.1686 72.0405 53.5675 72.2737 53.8411 72.6365L56.4491 76.122L63.6291 68.5063C63.9384 68.1817 64.3567 67.9995 64.7928 67.9995C65.2289 67.9995 65.6472 68.1817 65.9565 68.5063C66.1112 68.6683 66.234 68.861 66.3178 69.0734C66.4016 69.2858 66.4447 69.5136 66.4447 69.7436C66.4447 69.9737 66.4016 70.2015 66.3178 70.4138C66.234 70.6262 66.1112 70.8189 65.9565 70.981L57.4724 79.9386C57.165 80.2605 56.75 80.442 56.317 80.4439Z",
    fill: "#302322"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.5557,
    y: 47.7778,
    width: 18.6667,
    height: 3.11111,
    rx: 1.55555,
    fill: "#302322"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5557,
    y: 54,
    width: 18.6667,
    height: 3.11111,
    rx: 1.55556,
    fill: "#302322"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5557,
    y: 69.5557,
    width: 18.6667,
    height: 3.11111,
    rx: 1.55556,
    fill: "#302322"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5557,
    y: 60.2222,
    width: 9.33332,
    height: 3.11111,
    rx: 1.55556,
    fill: "#302322"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5557,
    y: 75.7778,
    width: 9.33332,
    height: 3.11111,
    rx: 1.55555,
    fill: "#302322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Current);
export default __webpack_public_path__ + "static/media/step1-current.44a17243d4c11ce2ea25174bbf36226e.svg";
export { ForwardRef as ReactComponent };